<template>
  <div class="table-responsive">
    <table ref="dataTable" :id="id" class="display cust-report-table table table-striped table-bordered earned_redeemed_table"
      :style="`width: ${tableWidth}`">
      <thead>
        <tr>
          <th v-for="(header, index) in headers" :key="index">{{ header }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(customer, index) in customers" :key="index">
          <td>{{ index + 1 }}</td>
          <td v-for="(value, key) in customer" :key="key" v-if="key != 'point_type'">
            <span v-if="key == 'created_at' && value">
              {{ value | moment("DD/MM/YYYY")  }}
            </span>
            <span v-else>
              {{ value }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: 'customer-report-summary-earned',

  components: {  },

  props: {
    headers: {
      type: Array,
      required: true
    },

    customers: {
      type: Array,
      required: true
    },
    
    tableWidth: {
      type: String,
      required: true
    },

    id: {
      type: String,
      required: true
    }
  },
}
</script>
